import { useRef } from "react";

const useOverRouterContext = () => {
  const contextRef = useRef({
    properties: {
      documentMessageActiveTab: false,
      quotationsStatus: ""
    },
    events: {
      onChangeDocumentStateFailed: [
        /*add here functions from anywhere*/
      ],
      onDocumentStateUpdated: () => {},
      onNavigationStepChanged: () => {},
      onQuotationsStatusChanged: () => {},
      onGenerationStatusChanged: () => {},
      onCascoQuotationsDataChanged: () => {}
    },
    functions: {}
  });

  return contextRef;
};

const useOverRouterContextUtils = contextRef => {
  const setProperties = properties => {
    if (contextRef && contextRef.current) {
      contextRef.current = {
        ...contextRef.current,
        properties: {
          ...contextRef.current.properties,
          ...properties
        }
      };
    }
  };

  const setEvents = events => {
    contextRef.current = {
      ...contextRef.current,
      events: {
        ...contextRef.current.events,
        ...events
      }
    };
  };

  const setContext = (events, functions) => {
    contextRef.current = {
      ...contextRef.current,
      events: {
        ...contextRef.current.events,
        ...events
      },
      functions: {
        ...contextRef.current.functions,
        ...functions
      }
    };
  };

  return { setProperties, setEvents, setContext };
};

export { useOverRouterContext, useOverRouterContextUtils };
